import { html, el } from '../html.js';
import { screen } from '../shell.js';
import { api } from '../api.js';
import { state } from '../state.js';
import { go } from '../router.js';
import { confirmAction } from '../dialog.js';

export async function inviteView() {
  const s = screen({ back: true });
  if (!state.user.isOwner) {
    s.body.append(el(html`<p class="stack">Only the owner can open this page.</p>`));
    return s.el;
  }
  const { members } = await api('GET', '/api/members');
  s.body.append(el(html`<div class="stack">
    <h1>Invite and members</h1>
    <button class="primary" type="button" data-create>Create invite link</button>
    <div class="invite stack-tight" hidden>
      <label class="field"><span>Invite link</span><input readonly data-g3-mask></label>
      <p>Anyone with this link can add places and photos.</p>
      <button class="secondary" type="button" data-copy>Copy link</button>
    </div>
    <h2>Members</h2>
    <ul class="members">${members.map(m => html`<li>
      <span>${m.username}${m.isOwner ? html` <span class="meta">owner</span>` : ''}</span>
      ${m.isOwner ? '' : html`<button class="destructive" type="button" data-remove="${m.id}" data-name="${m.username}">Remove</button>`}
    </li>`)}</ul>
  </div>`));
  const $ = sel => s.body.querySelector(sel);
  const link = $('.invite input');
  const create = $('[data-create]');
  create.addEventListener('click', async () => {
    create.disabled = true;
    try {
      link.value = (await api('POST', '/api/invites')).url;
      $('.invite').hidden = false;
    } catch (x) { s.status(x.message); }
    create.disabled = false;
  });
  $('[data-copy]').addEventListener('click', async () => {
    try {
      await navigator.clipboard.writeText(link.value);
      s.status('Link copied.');
    } catch {
      link.select(); // the person can copy it by hand
    }
  });
  s.body.querySelectorAll('[data-remove]').forEach(b => b.addEventListener('click', async () => {
    const name = b.dataset.name;
    if (!(await confirmAction(`Remove ${name} from the group? Their places and photos stay.`, 'Remove'))) return;
    try {
      await api('DELETE', `/api/members/${b.dataset.remove}`);
      go('/invite', 'Member removed.');
    } catch (x) { s.status(x.message); }
  }));
  return s.el;
}
